import { NUMBER_OPERATORS } from '../../filter/constants';
import { ListConductorRawFilter } from '../../list-conductor/filters';

export type OperandValue = string | number | Array<string | number> | undefined;

export function matchFilters(
  filters: ListConductorRawFilter[],
  getValueOfFilterKey: (filterkey: string) => OperandValue
) {
  if (!filters?.length) {
    return true;
  }

  return filters.every(filter =>
    evalFilterValueWithMatchValue(filter, getValueOfFilterKey(filter.fields[0]))
  );
}

const evalFilterValueWithMatchValue = (
  filter: ListConductorRawFilter,
  matchValue: OperandValue
) => {
  if (!matchValue) {
    return false;
  }

  const { values, operator } = filter;

  if (!values) {
    return true;
  }

  if (Array.isArray(matchValue)) {
    return matchValue.some(
      _matchValue => !!values.some(obj => operatorMapEval(obj, operator, _matchValue))
    );
  }

  return values.some(obj => operatorMapEval(obj, operator, matchValue));
};

const operatorMapEval = (value: OperandValue, operator: string, matchValue: OperandValue) => {
  if (NUMBER_OPERATORS.find(op => op.value === operator)) {
    const _value = parseFloat(value as string);
    return numericalOperation(_value, operator, parseInt(matchValue as string, 10));
  }

  return stringOperations(
    value!.toString().toLowerCase(),
    operator,
    matchValue!.toString().toLowerCase()
  );
};

const numericalOperation = (value: number, operator: string, matchValue: number) => {
  switch (operator) {
    case 'EQUALS':
      return matchValue === value;

    case 'GREATER_THAN':
      return matchValue > value;

    case 'GREATER_THAN_OR_EQUALS':
      return matchValue >= value;

    case 'NOT_EQUALS':
      return matchValue !== value;

    case 'LESSER_THAN':
      return matchValue < value;

    case 'LESSER_THAN_OR_EQUALS':
      return matchValue <= value;
    default:
      return false;
  }
};

const stringOperations = (value: string, operator: string, matchValue: string) => {
  switch (operator) {
    case 'EXACT_MATCH':
      return value === matchValue;
    case 'IN':
      return value === matchValue;
    case 'CONTAINS':
      return matchValue.includes(value);
    case 'STARTS_WITH':
      return matchValue.startsWith(value);
    case 'ENDS_WITH':
      return matchValue.endsWith(value);
    default:
      return false;
  }
};

export const getSearchValue = (filters: ListConductorRawFilter[], searchKey: string) => {
  const searchFilter = filters.find(_filter => _filter.fields.includes(searchKey));
  if (searchFilter) {
    return searchFilter.values[0];
  }
  return '';
};
